import bgImg1 from '~/assets/stat-flow/1.jpg'
import bgImg2 from '~/assets/stat-flow/2.jpg'
import bgImg3 from '~/assets/stat-flow/3.jpg'
import bgImg4 from '~/assets/stat-flow/4.jpg'

import { m } from '~/paraglide/messages'

type MessageFn = (params?: Record<string, string>) => string

const noop: MessageFn = () => ''

export const configByStep = {
  1: {
    classes: 'bg-[#01554D] text-[#3BE0D3]',
    btnClass:
      'bg-[#D1FFFB] text-[#25716B] border-[#1E9289] shadow-[0px_6px_#1E9289]',
    bgImg: bgImg1,
    titleFn: m.earth_day_2025_impact_tree as unknown as MessageFn,
    descFn: m.plant_more_trees as unknown as MessageFn,
    titleNumberByPlan: {
      1: 125,
      2: 250,
      3: 625,
      4: 2000,
    },
    descNumberByPlan: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
  2: {
    classes: 'bg-[#E0B45B] text-[#3F1F0A]',
    btnClass:
      'bg-[#FFF0D2] text-[#745139] border-[#B28226] shadow-[0px_6px_#B28226]',
    bgImg: bgImg2,
    titleFn: m.earth_day_2025_impact_co2_title as unknown as MessageFn,
    descFn: m.earth_day_2025_impact_co2_description as unknown as MessageFn,
    titleNumberByPlan: {
      1: 20,
      2: 40,
      3: 100,
      4: 320,
    },
    descNumberByPlan: {
      1: 80,
      2: 160,
      3: 400,
      4: 1280,
    },
  },
  3: {
    classes: 'bg-[#66BD4A] text-[#2A5412]',
    btnClass:
      'bg-[#DBFFCF] text-[#417027] border-[#4B8C35] shadow-[0px_6px_#4B8C35]',
    bgImg: bgImg3,
    titleFn: m.earth_day_2025_impact_land_title as unknown as MessageFn,
    descFn: m.earth_day_2025_impact_land_description as unknown as MessageFn,
    titleNumberByPlan: {
      1: 5,
      2: 10,
      3: 25,
      4: 80,
    },
    descNumberByPlan: {
      1: 0.5,
      2: 1,
      3: 3,
      4: 8,
    },
  },
  4: {
    classes: 'bg-[#88C5FF] text-[#267DC0]',
    btnClass:
      'bg-[#D5EBFF] text-[#33517C] border-[#4C7DAB] shadow-[0px_6px_#4C7DAB]',
    bgImg: bgImg4,
    titleFn: m.earth_day_2025_impact_water_title as unknown as MessageFn,
    descFn: m.earth_day_2025_impact_water_description as unknown as MessageFn,
    titleNumberByPlan: {
      1: 4000,
      2: 8000,
      3: 20000,
      4: 64000,
    },
    descNumberByPlan: {
      1: 1,
      2: 2,
      3: 5,
      4: 16,
    },
  },
  5: {
    classes: 'bg-[#513331]',
    bgImg: '',
    btnClass: '',
    titleFn: m.earth_day_2025_impact_conclude_title as unknown as MessageFn,
    descFn: noop,
    titleNumberByPlan: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
    descNumberByPlan: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    },
  },
}

export const resultNumbersByPlan: Record<
  number,
  { tree: number; co2: number; land: number; water: number }
> = {
  1: {
    tree: 125,
    co2: 20,
    land: 5,
    water: 4000,
  },
  2: {
    tree: 250,
    co2: 40,
    land: 10,
    water: 8000,
  },
  3: {
    tree: 650,
    co2: 100,
    land: 25,
    water: 20000,
  },
  4: {
    tree: 2000,
    co2: 320,
    land: 80,
    water: 64000,
  },
}
